import { INITIALIZE_MODULE, UPDATE_CHART_PARAMS } from '../actions/index'
import _ from 'lodash'
export default (state = {}, action) => {
    switch (action.type) {
        case INITIALIZE_MODULE:
            return _.pick(action.module, [
                'id',
                'name',
                'tKey',
                'category',
                'defaultPanel',
                'alerts',
                'noLeftBoard',
                'protectedExport',
                'useSocketsOnGet',
                'useSocketsOnFind',
                'useSocketsOnSave',
                'parentHeader',
                'headerClassName',
                'headerRowClassName',
                'headerHeight',
                'model',
                'accessUrl',
                'removable',
                'hideScroll',
                'sortable',
                'newable',
                'listable',
                'updatable',
                'charts',
                'impExp',
                'actions',
                'defaultFormButtons',
                'formSections',
                'deletionConfirmationMessage',
                'deletionConditions',
                'manualFilters',
                'buttonContainerStyle'
            ])
        case UPDATE_CHART_PARAMS:
            return {
                ...state,
                chartParams: {
                    ...state.chartParams,
                    ...action.data
                }
            }
        default:
            return state
    }
}
